let timeoutID: any;

const wait = (ms: number) =>
  new Promise<void>((resolve) => {
    timeoutID = setTimeout(() => {
      resolve();
    }, ms);
  });

const resetTimeout = () => {
  clearTimeout(timeoutID);
};

export { wait, resetTimeout };
